<template>
  <v-app>
    <RouterView></RouterView>
    <!-- 전역 AlertDialog (토큰 만료 등) -->
    <AlertDialog
      v-model="alertStore.isOpen"
      :persistent="true"
      :text="alertStore.message"
      @confirm="alertStore.confirm"
    />
  </v-app>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { RouterView } from "vue-router";
import { useCustomizerStore } from "@/stores/customizer";
import { useAlertStore } from "@/stores/alert";
import AlertDialog from "@/components/shared/AlertDialog.vue";

const customizerStore = useCustomizerStore();
const alertStore = useAlertStore();

onMounted(() => {
  customizerStore.initializeMiniSidebar();
});
</script>
